// src/components/Settings/Layout/RewardCenter.js

import React, { useEffect, useState, useContext } from "react";
import { FetchUserRewardData } from "../Utils/FetchUserRewardData";
// import { ThemeContext } from "../../../../context/ThemeContext";
import "../Styles/RewardCenter.css"

const RewardCenter = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  // const { theme } = useContext(ThemeContext);

  // useEffect(() => {
  //   import(`../Styles/themes/${theme}/themes.css`)
  //     .then(() => console.log(`Loaded ${theme} styles for RewardCenter`))
  //     .catch(() => console.error(`Theme CSS not found for ${theme}`));
  // }, [theme]);

  useEffect(() => {
    const loadUserData = async () => {
      const data = await FetchUserRewardData();
      setUserData(data);
      setLoading(false);
    };
    loadUserData();
  }, []);

  if (loading || !userData) {
    return (
      <div className="st-panel rc-root">
        <h2 className="st-panel-title">🎁 Reward Center</h2>
        <div className="rc-loading">
          <span>⏳ Loading reward data...</span>
        </div>
      </div>
    );
  }

  const {
    rewardCoins,
    socialCoins,
    companyRevenue,
    userCount,
    profiles
  } = userData;

  // Derive additional metrics
  const impressionCoins = Math.floor((userData.userImpressions || 0) / 1000);
  const inviteCoins = userData.coinHistory?.filter(h => h.reason === "Invite Accepted").length * 2 || 0;
  const profileCoins = profiles?.length || 0;

  const coinValue = userCount > 0 ? (companyRevenue / userCount).toFixed(2) : "0.00";
  const totalCoins = rewardCoins + socialCoins;
  const totalValue = (totalCoins * parseFloat(coinValue)).toFixed(2);

  return (
    <div className="st-panel rc-root">
      <h2 className="st-panel-title">🎁 Reward Center</h2>
      <p className="st-panel-subtitle">
        Manage your digital coins and track how you earn rewards through engagement.
      </p>

      {/* ════════════════════════════════════════════════════════════════
          HEADER SECTION
          ════════════════════════════════════════════════════════════════ */}
      <div className="rc-header" style={{background: "rgba(36,36,45,0.2)", border: "1px solid gray"}} >
        <div className="rc-header-content">
          <h3 className="rc-header-title">Oowlet Reward System</h3>
          <p className="rc-header-desc">
            Earn <strong>Reward Coins</strong> and <strong>Social Coins</strong> based on your
            content engagement, community involvement, and social trust.
          </p>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════════════
          COIN ALLOCATION RULES
          ════════════════════════════════════════════════════════════════ */}
      <div className="rc-rules-grid">
        {/* Reward Coins */}
        <div className="rc-rule-card rc-rule-card--reward">
          <h4 className="rc-rule-title">Reward Coins</h4>
          <ul className="rc-rule-list">
            <li>1 coin for joining the platform</li>
            <li>1 coin per content creation</li>
            <li>Relative coins per posting content</li>
            <li>1 coin for every 1,000 impressions</li>
            <li>Bonus coins for 500+ impressions</li>
          </ul>
        </div>

        {/* Social Coins */}
        <div className="rc-rule-card rc-rule-card--social">
          <h4 className="rc-rule-title">Social Coins</h4>
          <ul className="rc-rule-list">
            <li>2 coins per invite accepted</li>
            <li>5 coins for event creation</li>
            <li>Coins awarded by peer reviews</li>
            <li>Community contribution rewards</li>
          </ul>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════════════
          COIN SUMMARY SECTION
          ════════════════════════════════════════════════════════════════ */}
      <div className="rc-summary">
        <h3 className="rc-summary-title"> Your Coin Summary</h3>
        <div className="rc-summary-grid">
          {/* Left Column */}
          <div className="rc-summary-col">
            <div className="rc-summary-item">
              <span className="rc-summary-icon">💎</span>
              <div className="rc-summary-text">
                <span className="rc-summary-label">Reward Coins {rewardCoins} </span>
              </div>
            </div>

            <div className="rc-summary-item">
              <span className="rc-summary-icon">👥</span>
              <div className="rc-summary-text">
                <span className="rc-summary-label">Social Coins {socialCoins} </span>
              </div>
            </div>

            <div className="rc-summary-item">
              <span className="rc-summary-icon">👁</span>
              <div className="rc-summary-text">
                <span className="rc-summary-label">Impression Coins {impressionCoins}</span>
              </div>
            </div>

            <div className="rc-summary-item">
              <span className="rc-summary-icon">📧</span>
              <div className="rc-summary-text">
                <span className="rc-summary-label">Invite Coins {inviteCoins} </span>
              </div>
            </div>

            <div className="rc-summary-item">
              <span className="rc-summary-icon">🎭</span>
              <div className="rc-summary-text">
                <span className="rc-summary-label">Profile Coins {profileCoins} </span>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="rc-summary-col rc-summary-col--highlight" style={{background: "rgba(36,36,45,0.2)" }}>
            <div className="rc-summary-item rc-summary-item--large">
              <span className="rc-summary-icon" style={{ fontSize: "2rem" }}>✨</span>
              <div className="rc-summary-text">
                <span className="rc-summary-label">Total Coins {totalCoins} </span>
              </div>
            </div>

            <div className="rc-divider"></div>
            <div className="rc-summary-item">
              <span className="rc-summary-icon">💰</span>
              <div className="rc-summary-text">
                <span className="rc-summary-label">Company Revenue ₹{companyRevenue.toLocaleString()} </span>
              </div>
            </div>

            <div className="rc-summary-item">
              <span className="rc-summary-icon">👨</span>
              <div className="rc-summary-text">
                <span className="rc-summary-label">User Count {userCount.toLocaleString()} </span>
              </div>
            </div>

            <div className="rc-summary-item">
              <span className="rc-summary-icon">📈</span>
              <div className="rc-summary-text">
                <span className="rc-summary-label">Coin Value ₹{coinValue} </span>
              </div>
            </div>

            <div className="rc-summary-item rc-summary-item--total">
              <span className="rc-summary-icon">💵</span>
              <div className="rc-summary-text">
                <span className="rc-summary-label">Total Coin Value ₹{totalValue}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════════════
          RETENTION BENEFIT
          ════════════════════════════════════════════════════════════════ */}
      <div className="rc-benefit" style={{background: "rgba(36,36,45,0.2)", border: "1px solid gray"}}>
        <span className="rc-benefit-icon">🔒</span>
        <div>
          <h4 className="rc-benefit-title" style={{color: "white"}}>Why Retain Your Coins?</h4>
          <p className="rc-benefit-desc">
            Coins grow in value as the platform scales in revenue and user engagement. Retaining
            coins now can lead to higher future rewards, exclusive access, and priority benefits.
            Think of it like ESOPs—but for contributors.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RewardCenter;
